import { CommonActions } from '@bugbug/core/actions/actions';
import { useCallback, useMemo } from 'react';

import { useAppDispatch } from '~/modules/store';
import { TestRunActions } from '~/modules/testRun/testRun.redux';

import { testsApi } from '../../tests.api';

export const useCurrentTest = () => {
  const dispatch = useAppDispatch();
  const [getCurrentTest, testRequest] = testsApi.useLazyGetCurrentTestQuery();

  const handleGetCurrentTest = useCallback(
    async (...args: Parameters<typeof getCurrentTest>) => {
      const [{ id, testRunId }, preferCache = false] = args;

      const result = getCurrentTest({ id, testRunId }, preferCache).unwrap();

      result
        .then(({ test }) => {
          if (test.testRun) {
            dispatch(TestRunActions.getSingleSuccess(test.testRun));
          }

          dispatch(
            CommonActions.setIsSingleLoading({
              isLoading: false,
              testId: id,
            }),
          );
        })
        .catch(() => {});
    },
    [dispatch, getCurrentTest],
  );

  return useMemo(
    () => [handleGetCurrentTest, testRequest] as const,
    [handleGetCurrentTest, testRequest],
  );
};
